export const COOKIE_TYPES = {
    REQUIRED: "required",
    ANALYTICS: "analytics",
    MARKETING: "marketing",
    SOCIAL: "social",
} as const;

export type CookieType = (typeof COOKIE_TYPES)[keyof typeof COOKIE_TYPES];

export const ALL_COOKIE_TYPES: CookieType[] = Object.values(COOKIE_TYPES);

export const COOKIE_ACTIONS = {
    DECLINE: "decline",
    CONFIGURE: "configure",
    ACCEPT_SELECTED: "accept-selected",
    ACCEPT_ALL: "accept-all",
} as const;

export type CookieActionsType = (typeof COOKIE_ACTIONS)[keyof typeof COOKIE_ACTIONS];
